<template>
  <div class="list-box" style="padding: 0">
    <ul class="list-search">
      <el-space wrap style="flex: 1">
        <el-input
          v-model="state.params.name"
          style="width: 200px"
          placeholder="姓名"
          clearable
          @clear="
            delete state.params.name;
            onLoad();
          "
        ></el-input>
        <el-dropdown split-button @click="onLoad" type="primary">
          查询
          <template #dropdown>
            <el-dropdown-menu>
              <el-dropdown-item :icon="RefreshLeft" @click="onReset()">
                重置
              </el-dropdown-item>
            </el-dropdown-menu>
          </template>
        </el-dropdown>
        <div style="line-height: 30px; color: #a2a2a2; margin-right: 10px">
          已选择：<strong style="color: #f00">{{
            state.selectIds?.length || 0
          }}</strong
          >条数据
        </div>
      </el-space>
      <li
        style="
          flex: 1;
          display: flex;
          justify-content: flex-end;
          align-items: center;
          line-height: 10px;
        "
      >
        <text style="color: #a2a2a2; font-size: 14px">算税人数：</text>
        <text style="font-size: 15px; color: #1e90ff">{{
          props.model?.total_num
        }}</text>
        <text style="color: #a2a2a2; font-size: 14px; margin-left: 10px"
          >已算税：</text
        >
        <text style="font-size: 15px; color: #080">{{
          props.model?.done_num
        }}</text>
        <text style="color: #a2a2a2; font-size: 14px; margin-left: 10px"
          >未算税：</text
        >
        <text style="font-size: 15px">{{ props.model?.undone_num }}</text>
        <text style="color: #a2a2a2; font-size: 14px; margin-left: 10px"
          >算税失败：</text
        >
        <text style="font-size: 15px; color: #f00">{{
          props.model?.abnormal_num
        }}</text>
        <template v-if="props.model.status == 0 && $judge_auth('57')">
          <el-button
            link
            type="danger"
            icon="Tickets"
            @click="onSetFailure"
            style="margin-left: 20px"
          >
            标记失败
          </el-button>
          <el-button
            link
            type="success"
            icon="Tickets"
            @click="onSetSuccess"
            style="margin-left: 20px"
          >
            标记成功
          </el-button>
          <el-button
            link
            type="primary"
            icon="Download"
            @click="state.showImport = true"
          >
            导入算税单
          </el-button></template
        >
      </li>
    </ul>
    <div
      class="table-container"
      v-loading="!Array.isArray(state.tableData)"
      element-loading-background="rgba(0, 0, 0, 0.2)"
    >
      <table
        cellpadding="20"
        cellspacing="0"
        v-if="Array.isArray(state.tableData)"
      >
        <thead>
          <tr>
            <th>
              <input
                type="checkbox"
                id="all"
                @change="onAllChecked"
                :disabled="!(props.model.status == 0 && $judge_auth('57'))"
              />
            </th>
            <th style="white-space: nowrap">序号</th>
            <th style="white-space: nowrap; text-align: center">算税状态</th>
            <th style="white-space: nowrap">发放状态</th>
            <th
              style="white-space: nowrap"
              v-for="item in state.templateSortFields"
              :key="item"
            >
              {{ item.name }}
            </th>
            <th style="text-align: center">操作</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(row, rowIndex) in state.tableData"
            :key="row"
            @click="
              props.model.status == 0 && $judge_auth('57')
                ? onRowClick(row.id)
                : ''
            "
          >
            <td>
              <input
                type="checkbox"
                :id="row.id"
                :key="state.key"
                :checked="state.selectIds?.includes(row.id)"
                :disabled="!(props.model.status == 0 && $judge_auth('57'))"
              />
            </td>
            <td style="white-space: nowrap">{{ rowIndex + 1 }}</td>
            <td style="white-space: nowrap">
              <el-tooltip
                effect="dark"
                :content="row.tax_failure_msg"
                v-if="row.tax_failure_msg"
              >
                <div
                  style="
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    cursor: pointer;
                  "
                >
                  <c_status
                    arrName="payrollemployee_tax_status"
                    :value="row.tax_status"
                  />
                  <el-icon><QuestionFilled /></el-icon>
                </div>
              </el-tooltip>
              <c_status
                arrName="payrollemployee_tax_status"
                :value="row.tax_status"
                style="margin: 0 auto"
                v-else
              ></c_status>
            </td>
            <td style="white-space: nowrap">
              <el-tooltip
                effect="dark"
                :content="row.pay_failure_msg"
                v-if="row.pay_failure_msg"
              >
                <div
                  style="
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    cursor: pointer;
                  "
                >
                  <c_status
                    arrName="payrollemployee_pay_status"
                    :value="row.pay_status"
                  />
                  <el-icon><QuestionFilled /></el-icon>
                </div>
              </el-tooltip>
              <c_status
                arrName="payrollemployee_pay_status"
                :value="row.pay_status"
                style="margin: 0 auto"
                v-else
              ></c_status>
            </td>
            <td
              style="white-space: nowrap; text-align: center"
              v-for="item in state.templateSortFields"
              :key="item"
            >
              {{ row[item.field] || "-" }}
            </td>
            <td
              style="
                white-space: nowrap;
                text-align: center;
                padding-left: 30px;
                padding-right: 30px;
              "
            >
              <el-button
                type="primary"
                link
                icon="Edit"
                @click.stop="
                  state.selectItem = row;
                  state.showEdit = true;
                "
                :disabled="props.model.status !== 0"
              >
                编辑
              </el-button>
            </td>
          </tr>
          <tr>
            <td colspan="2" style="text-align: left">合计</td>
            <td v-for="item in state.statistics" :key="item">
              {{ item }}
            </td>
            <td></td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  <el-dialog
    v-model="state.showImport"
    title="导入外协算税单"
    width="40%"
    align-center
  >
    <c_CalcTaxOutsourceImport
      v-if="state.showImport"
      :id="props.model?.id"
      @success="onImportSuccess"
    ></c_CalcTaxOutsourceImport>
  </el-dialog>
  <transition name="el-zoom-in-center">
    <c_popup
      v-if="state.showEdit"
      title="编辑员工"
      @close="state.showEdit = false"
    >
      <c_CalcTaxOutsourceEdit
        v-if="state.showEdit"
        :item="state.selectItem"
        :templateSortFields="state.templateSortFields"
        :id="props.model?.id"
        @success="
          state.showEdit = false;
          onLoad();
        "
      ></c_CalcTaxOutsourceEdit>
    </c_popup>
  </transition>
</template>

<script>
import { onMounted, reactive, ref } from "vue";
import {
  calctaxoutsource_records,
  calctaxoutsource_setfailure,
  calctaxoutsource_setDone,
} from "@/http/calctaxoutsource";
import { priceFormat } from "@/utils/qFormat";
import { ElMessage, ElMessageBox } from "element-plus";

export default {
  props: {
    model: Object,
  },
  setup(props) {
    const tableDom = ref(null);
    const state = reactive({
      params: {},
      statistics: [],
      templateSortFields: [],
      selectFile: {},
      withholding_agent: {},
      selectIds: [],
    });
    onMounted(() => {
      state.params.id = props.model?.id;
      onLoad();
    });

    const onLoad = () => {
      delete state.tableData;

      calctaxoutsource_records(state.params).then((res) => {
        if (res.status == 200) {
          const { list, statistics, templateSortFields } = res.data.data;
          state.tableData = list;
          state.templateSortFields = templateSortFields;

          let tjArr = [];
          const keys = Object.keys(statistics);
          keys.forEach((key) => {
            const index = state.templateSortFields.findIndex(
              (w) => w.field == key
            );
            if (index > -1) tjArr[index + 2] = priceFormat(statistics[key]);
          });
          tjArr.length = tjArr.length + 6;
          state.statistics = tjArr;
        }
      });
    };

    const onAllChecked = (item) => {
      const { checked } = item.target;
      if (checked) {
        state.selectIds = state.tableData?.map((m) => m.id);
      } else {
        state.selectIds = [];
      }
      state.key = Math.random();
    };

    const onRowClick = (id) => {
      // tableDom.value.toggleRowSelection(row);
      const index = state.selectIds.findIndex((w) => w == id);
      if (index > -1) {
        state.selectIds.splice(index, 1);
      } else {
        state.selectIds.push(id);
      }
    };

    //排序
    const onSortChange = ({ column }) => {
      if (column.order) {
        state.params.sort_field = column.sortable;
        state.params.sort_value = column.order === "ascending" ? "asc" : "desc";
      }
      onLoad();
    };

    const onSetFailure = () => {
      if (state.selectIds?.length <= 0) {
        ElMessage({
          type: "warning",
          message: "请选择要操作的数据！",
          grouping: true,
        });
        return false;
      }

      ElMessageBox.prompt(
        `您确定将已选的<strong style='color:#1e90ff'>${state.selectIds?.length}人</strong>标记为<strong style='color:#f00'>失败</strong>状态吗？`,
        "标记失败",
        {
          dangerouslyUseHTMLString: true,
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          inputPlaceholder: "请填写失败原因",
          inputValidator: (value) => {
            if (!value) return false;
            else return true;
          },
          inputErrorMessage: "请填写失败原因",
        }
      ).then(({ value }) => {
        const data = {
          id: props.model?.id,
          payroll_employee_id: state.selectIds.join(","),
          tax_failure_msg: value,
        };
        calctaxoutsource_setfailure(data).then((res) => {
          if (res.status == 200) {
            ElMessage.success(res.data.msg);
            onLoad();
          }
        });
      });
    };

    const onSetSuccess = () => {
      if (state.selectIds?.length <= 0) {
        ElMessage({
          type: "warning",
          message: "请选择要操作的数据！",
          grouping: true,
        });
        return false;
      }

      ElMessageBox.confirm(
        `您确定将已选的<strong style='color:#1e90ff'>${state.selectIds?.length}人</strong>标记为<strong style='color:#080'>已算税</strong>状态吗？`,
        "标记成功",
        {
          dangerouslyUseHTMLString: true,
          confirmButtonText: "确定",
          cancelButtonText: "取消",
        }
      ).then(() => {
        const data = {
          id: props.model?.id,
          payroll_employee_id: state.selectIds.join(","),
        };
        calctaxoutsource_setDone(data).then((res) => {
          if (res.status == 200) {
            ElMessage.success(res.data.msg);
            onLoad();
          }
        });
      });
    };

    const onImportSuccess = () => {
      onLoad();
      state.showImport = false;
    };

    return {
      state,
      tableDom,
      props,
      onLoad,
      onRowClick,
      onSortChange,
      onSetFailure,
      onSetSuccess,
      onImportSuccess,
      onAllChecked,
    };
  },
};
</script>
<style lang="less" scoped>
.table-container::-webkit-scrollbar {
  width: 15px;
  height: 15px;
}

.table-container::-webkit-scrollbar-thumb {
  border-radius: 8px;
  background-color: #61b0f5;
}

.table-container::-webkit-scrollbar-track {
  border-radius: 8px;
  background-color: transparent;
}

.table-container {
  min-height: 300px;
  overflow-y: auto; /* 垂直滚动条 */
  display: block; /* 或者使用 overflow: scroll; */
  border: 1px solid #ebeef5;
  font-size: 14px;
  color: #606266;

  table {
    width: 100%; /* 或者具体的宽度 */
    border-collapse: separate; /* 合并边框 */
  }

  thead th {
    position: sticky; /* 使表头固定 */
    top: 0; /* 固定在顶部 */
    z-index: 1; /* 确保表头在其他内容之上 */
    background-color: #fff;
    border-bottom: 1px solid #ebeef5;
    color: #909399;
  }

  th,
  td {
    position: -webkit-sticky; /* Safari */
    position: sticky;
  }

  /* 固定第一列 */
  thead th:first-child {
    top: 0;
    left: 0;
    z-index: 10; /* 确保在最上层 */
    background-color: #fff;
  }

  tbody td:first-child {
    left: 0;
    z-index: 2; /* 确保在最上层 */
    background-color: #fff;
    border-bottom: 1px solid #ebeef5;
  }

  tbody td {
    border-bottom: 1px solid #ebeef5;
  }

  /* 固定第一列 */
  thead th:last-child {
    top: 0;
    right: 0;
    z-index: 10; /* 确保在最上层 */
    background-color: #fff;
  }

  tbody td:last-child {
    right: 0;
    z-index: 2; /* 确保在最上层 */
    background-color: #fff;
  }

  tbody tr:last-child {
    position: sticky; /* 使表头固定 */
    background-color: #fff;
    bottom: 0;
    z-index: 30; /* 确保在最上层 */
    background-color: #fff;

    & > td {
      padding-top: 10px;
      padding-bottom: 10px;
      background-color: rgb(246, 246, 246);
      text-align: center;
    }
  }
}
</style>
